import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'

globalEventBus.on('challenge stats data wanted', getStats)


globalEventBus.on('challenge loaded', ({id}) => {
    if (id in dataCache) {
        setTimeout(() => emit(id), 40)
    }
})


const dataCache = {}

function getStats (challengeId) {
    let {port} = window.location
    if (port !== '8089') {
        console.error('Not working because of CORS : you should serve this on port 8089, not on ' + port)
        return
    }
    if (challengeId in dataCache) {
        emit(challengeId)
    } else {
        let url = 'https://compute-it-stats.toxicode.fr/stats.json?levelId=' + challengeId
        $.getJSON(url, (challengeData) => {
            dataCache[challengeId] = challengeData
            globalEventBus.emit('stats data loaded', challengeData)
        })
    }
}


function emit (challengeId) {
    globalEventBus.emit('stats data loaded', dataCache[challengeId])
}


export default getStats
